export default __webpack_public_path__ + "static/media/earth.ee84810d.png";